import React from "react"

import Studio from "./studio/Studio"
import WithObjects from "data/wrappers/WithObjects"
import Table from "ui/components/Table"
import Card from "ui/components/Card"
import PageTitle from "ui/components/PageTitle"

export default class Test extends React.Component {
    render() {
        return (
            <Studio>
                <PageTitle>Objects</PageTitle>
                <WithObjects>
                    {({ objects }) => {
                        const sample = objects[0] || {}
                        const columns = Object.keys(sample).map(key => ({
                            accessor: key,
                            Header: key,
                        }))
                        return (
                            <Card>
                                <Table columns={columns} data={objects} />
                            </Card>
                        )
                    }}
                </WithObjects>
            </Studio>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/Test.js